module.exports = __webpack_public_path__ + "img/fitness2.f3e1f039.png";